import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';

import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { getStorage, setStorage, updateFilterUrl } from "../../helper.js";



export default function AttendanceReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const [fy] = useOutletContext();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);





  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    setValue,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'attendance-report', 1), { replace: location.search ? true : false })


  };





  const headers = [
    { label: "S.no.", key: "sno" },
    { label: "Staff Name", key: "name" },
    { label: "Present", key: "present" },
    { label: "Half Day", key: "half_day" },
    { label: "Over Time", key: "over_time" },
    { label: "Holiday", key: "holiday" },
    { label: "Absent", key: "absent" },
    { label: "Payable Days", key: "days" },

  ];

  const pdf_columns = [
    {
      title: 'S.no.',
      dataIndex: 'sno',
      key: 'sno',
    },
    {
      title: 'Staff Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Present',
      dataIndex: 'present',
      key: 'present',
    },
    {
      title: 'Half Day',
      dataIndex: 'half_day',
      key: 'half_day',
    },
    {
      title: 'Over Time',
      dataIndex: 'over_time',
      key: 'over_time',
    },
    {
      title: 'Holiday',
      dataIndex: 'holiday',
      key: 'holiday',
    },
    {
      title: 'Absent',
      dataIndex: 'absent',
      key: 'absent',
    },
    {
      title: 'Payable Days',
      dataIndex: 'days',
      key: 'days',
    },

    


  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/attendance_report" + filter
    );

    var dataa = data;

    return dataa;

  }

  const defaultValues = {
    date: null,
  };



  useEffect(() => {
    queryClient.invalidateQueries(['attendance-report'])
  }, [fy]);


  useEffect(() => {

    if (location.search) {
    } else {
      setFilter(defaultValues)
    }




  }, [location]);



  useEffect(() => {


    const parsed = queryString.parse(location.search);



    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'S.no.',
      width: '30px',
      dataIndex: 'sno',

    },
    {
      title: 'Staff Name',
      width: '100px',
      dataIndex: 'name',
      sorter: 'name',
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
    },
  
    {
      title: 'Present', 
      width: '50px',
      dataIndex: 'present',
    },

    {
      title: 'Half Day',
      width: '50px',
      dataIndex: 'half_day',
    },

    {
      title: 'Over Time',
      width: '50px',
      dataIndex: 'over_time',
    },

    {
      title: 'Holiday',
      width: '50px',
      dataIndex: 'holiday',
    },

    {
      title: 'Absent',
      width: '50px',
      dataIndex: 'absent',
    },

    {
      title: 'Payable Days',
      width: '50px',
      dataIndex: 'days',
    },




  ];




  const { data, error, isError, isLoading, isFetching } = useQuery(["attendance-report", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        from: filter.from? filter.from : data && data.from ? data.from : null,
        to: filter.to? filter.to : data && data.to ? data.to : null,
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {

    if (data && data.from) {
      setValue('from', data.from)
      setValue('to', data.to)
    }

  }, [data]);







  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }

    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }


    if (location.search) {
      navigate('/attendance-report?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/attendance-report?' + currentUrlParams.toString())
    }




  };
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };



  const expandedRowRender = (row) => {
    const columns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',

      },
      {
        title: 'Attendance',
        dataIndex: 'type',
        key: 'type',
      },



    ];

    return <Table columns={columns} dataSource={row.entries} pagination={false} />;
  };




  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
       Attendance Report
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Attendance Report" >
            {data.items &&
              <><ExportPDFButton columns={pdf_columns} data={data.items} title="attendance-report" company={data.company} company_desc={data.company_desc} heading1="Attendance Report" heading2="" heading3={`${data.from} - ${data.to}`} />
                <CSVLink data={data.items} filename={"attendance-report.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4 pb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="from"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="From"
                          onChange={onChange}
                          default_val={value}
                          message={errors.from?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">

                    <Controller

                      name="to"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="To"
                          onChange={onChange}
                          default_val={value}
                          message={errors.to?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

             



                  <div className="col-md-1 mb-2" style={{ paddingTop: '28px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>




            <Table
              locale={{
                emptyText: (<TableZero title="Parties" />)
              }}
              expandable={{
                expandedRowRender,
                defaultExpandedRowKeys: ['0'],
              }}
              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={false}
              loading={{ spinning: (tableDisable || isFetching) }}
              onChange={handleTableChange}
              scroll={{
                x: 960,

              }}
            />

          </div>
        </div>
      </div>
    </>
  );
}
